import { defineComponent as t, createBlock as a, openBlock as l, unref as r, mergeProps as c, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconThumbsDownFilled",
  __name: "IconThumbsDownFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (d, e) => (l(), a(r(m), c(n, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M19.73 12.066a2.067 2.067 0 0 1 .533.36 1.923 1.923 0 0 1 0 2.814c-.41.384-.977.593-1.638.593H12.54l.476 2.383a3.046 3.046 0 0 1-1.624 3.323 1.21 1.21 0 0 1-1.648-.594l-3.172-7.191a5.237 5.237 0 0 1-.165-.42H4.375a1.25 1.25 0 0 1-1.25-1.25v-6a1.25 1.25 0 0 1 1.25-1.25h2.5a.76.76 0 0 1 .08.004 2.24 2.24 0 0 1 1.42-.505h7.75c.66 0 1.229.21 1.638.594a1.924 1.924 0 0 1 .464 2.146c.706.343 1.124 1.013 1.13 1.754a1.92 1.92 0 0 1-.25.968 1.924 1.924 0 0 1 .623 2.271M6.139 6.333H4.625v5.5h1.504a5.253 5.253 0 0 1-.004-.198V6.583a2.275 2.275 0 0 1 .014-.25",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
